import { HelpContent } from '../../UI-Lib/Help-Tooltip';

export const ELECTRONIC_FILING_HELP: HelpContent[] = [
    {
        helpContentId: 'electronic-filing.options',
        tooltipText: 'Please indicate if you would like to download a separate electronic file per assessor or if you would like all selected assessors included in one electronic file.',
        hasIcon: true
    }
];
